import { Tooltip, Icon } from '@intellecteu/common-ui';

import s from './styles.module.scss';

interface ValidatorCellProps {
  validatorParent: string;
}

export const ValidatorCell = ({ validatorParent }: ValidatorCellProps) => {
  return (
    <Tooltip
      text={`Validator: ${validatorParent}`}
      tooltipType="info"
      className={s.validatorTooltip}
      textClassName={s.validatorTooltipText}
      placement="top"
    >
      <div className={s.validatorIndicator}>
        <Icon icon={Icon.icons.peer} size="xs" />
      </div>
    </Tooltip>
  );
};
